import { render, staticRenderFns } from "./quickBuy_new.vue?vue&type=template&id=71f55f7d&scoped=true&"
import script from "./quickBuy_new.vue?vue&type=script&lang=js&"
export * from "./quickBuy_new.vue?vue&type=script&lang=js&"
import style0 from "./quickBuy_new.vue?vue&type=style&index=0&id=71f55f7d&lang=less&scoped=true&"
import style1 from "./quickBuy_new.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f55f7d",
  null
  
)

component.options.__file = "quickBuy_new.vue"
export default component.exports